import React from "react";
import JSONLD from "web/react/components/json-ld/json-ld";

interface PaywallMarkupProps {
    cssSelector: string;
}

export function PaywallMarkup({ cssSelector }: PaywallMarkupProps): JSX.Element {
    const jsonLDData = {
        "@context": "https://schema.org",
        "@type": "CreativeWork",
        isAccessibleForFree: "False",
        hasPart: {
            "@type": "WebPageElement",
            isAccessibleForFree: "False",
            cssSelector: `.${cssSelector}`,
        },
    };

    return <JSONLD JSONLD={jsonLDData} />;
}

export default PaywallMarkup;
